/**
 * Formats milliseconds into MM:SS display format
 * Used by GameStopwatch and FinishedModal for consistency
 */
export const formatTimerDisplay = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
